import gql from 'graphql-tag';

export const CONFIGURE_TASKS = gql`
  mutation ConfigureTasks($payload: String!) {
    ConfigureTasks(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const GET_ADMIN_CONFIGURED_TASKS = gql`
  query GetConfiguredTasks($filter: String) {
    GetConfiguredTasks(filter: $filter) {
      InspectionTask {
        CreatedOn
        Id
        IsRequired
        Name
      }
      TaskClassificationAssignments {
        ClassificationCode
        ClassificationId
        ClassificationName
        Id
      }
      TaskDepartments {
        DepartmentId
        Id
        IsPrimary
      }
      DeleteOperations {
        InspectionTaskClassificationAssignmentIds
        InspectionTaskDepartmentIds
      }
    }
  }
`;
export const GET_ALL_TASK_CLASSIFICATIONS = gql`
  query GetAllTaskClassifications {
    GetTaskClassifications {
      Id
      SubType
      Type
      Codes {
        Id
        Code
      }
    }
  }
`;
